import { DocumentReceiptEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import { convertReceiptCsv } from '../Receipt/convertReceiptCsv';
import { expandReceiptTable } from '../Receipt/expandReceiptTable';
import { formDataToEntity } from '../Receipt/formDataToEntity';
import { PayeeColumn } from '../Receipt/PayeeColumn';
import { ReceiptFormInputs } from '../Receipt/ReceiptFormInputs';
import renderTableColumn from './renderTableColumn';
import { OcrResultPageDefinition } from './types';

const receiptResultPageDefinition: OcrResultPageDefinition<DocumentReceiptEntity> = {
  name: ocrTypeNameDefinitions.receipt,
  tabs: [
    {
      csvColumns: {},
      tableColumns: [
        { dataIndex: ['latest_revision', 'payment_date'], title: '支払い日付', render: renderTableColumn },
        {
          dataIndex: ['latest_revision'],
          title: '摘要',
          render: (record: DocumentReceiptEntity) => <PayeeColumn record={record} />,
        },
        {
          dataIndex: ['latest_revision', 'business_number'],
          title: '事業者番号',
          render: renderTableColumn,
        },
      ],
      tableExpandable: {
        expandedRowRender: expandReceiptTable,
      },
    },
  ],
  formComponent: ReceiptFormInputs,
  formDataToEntity,
  csvDataConverters: [
    {
      converter: convertReceiptCsv,
    },
  ],
};

export default receiptResultPageDefinition;
